<template>
  <div class="redemptions-view-page">
    <b-loading :is-full-page="false" :active.sync="isLoading"></b-loading>
    <app-page-header :title="['Resgates', 'Visualizar']">
      <button
        type="button"
        v-app-button.clear.icon-left
        v-app-back-button="{ name: 'redemptions.index' }"
      >
        <b-icon size="small" icon="arrow-left"></b-icon>Voltar
      </button>
    </app-page-header>

    <app-card v-if="!isLoading">
      <div class="row">
        <div class="col-3">
          <app-input
            :model="redemption.created_at | date('DD/MM/YYYY HH:mm')"
            label="Data e Hora"
            disabled
          ></app-input>
        </div>
        <div class="col-3">
          <app-input :model="redemption.type" label="Tipo" disabled></app-input>
        </div>
        <div class="col-3">
          <app-input
            :model="redemption.client.network.name"
            label="Rede"
            disabled
          ></app-input>
        </div>
        <div class="col-3">
          <app-input
            :model="redemption.name"
            label="Nome Vendedor"
            disabled
          ></app-input>
        </div>
        <div class="col-3">
          <app-input
            :model="redemption.client.cpf | VMask('###.###.###-##')"
            label="CPF"
            disabled
          ></app-input>
        </div>
      </div>
      <div class="row">
        <div class="col-3">
          <app-input
            v-model="redemption.address"
            label="Endereço"
            disabled
          ></app-input>
        </div>
        <div class="col-3">
          <app-input
            v-model="redemption.neighborhood"
            label="Bairro"
            disabled
          ></app-input>
        </div>
        <div class="col-3">
          <app-input
            v-model="redemption.city"
            label="Cidade"
            disabled
          ></app-input>
        </div>
        <div class="col-3">
          <app-input
            :model="redemption.zip_code | VMask('##.###-###')"
            label="CEP"
            disabled
          ></app-input>
        </div>
      </div>
      <div class="row">
        <div class="col-2">
          <app-input
            :model="`R$ ${redemption.points.toLocaleString('pt-BR')}`"
            label="Pontos"
            disabled
          ></app-input>
        </div>
        <div class="col-2">
          <app-input
            :model="`R$ ${redemption.value.toLocaleString('pt-BR')}`"
            label="Valor"
            disabled
          ></app-input>
        </div>
        <div class="col-2">
          <app-input
            :model="`R$ ${redemption.exchange_rate.toLocaleString('pt-BR')}`"
            label="Câmbio"
            disabled
          ></app-input>
        </div>
        <div class="col-3">
          <app-input
            v-model="redemption.status"
            label="Status"
            disabled
          ></app-input>
        </div>
        <div class="col-3">
          <app-input
            v-model="redemption.card"
            label="Número do Cartão"
            disabled
          ></app-input>
        </div>
      </div>
    </app-card>
  </div>
</template>

<script>
import RedemptionService from '@/services/redemption.service';

export default {
  name: 'redemptions-view-page',
  data: () => {
    return {
      isLoading: true,
      redemption: {},
    };
  },
  methods: {
    load(id) {
      RedemptionService.getId(id)
        .then(({ data: redemption }) => (this.redemption = redemption))
        .catch(() => this.toastify('Erro ao carregar Resgate.', 'error'))
        .finally(() => (this.isLoading = false));
    },
  },
  beforeMount() {
    this.load(this.$route.params.id);
  },
};
</script>
